// import resultDataURL from "../resultSample";
import { combineReducers } from "redux";
import target from "./target";
import tiles, * as fromTiles from "./tiles";
import preview from "./preview";
import editorsPicks from "./editorsPicks";

const generating = (state = false, action) => {
  switch (action.type) {
    case "START_GENERATING_MOSAIC":
      return true;
    case "MOSAIC_GENERATION_ERROR":
    case "FINISH_GENERATING_MOSAIC":
      return false;
    default:
      return state;
  }
};
const error = (state = null, action) => {
  switch (action.type) {
    case "START_GENERATING_MOSAIC":
      return false;
    case "MOSAIC_GENERATION_ERROR":
      return true;
    default:
      return state;
  }
};
const progress = (state = 0, action) => {
  switch (action.type) {
    case "START_GENERATING_MOSAIC":
      return 0;
    case "SET_MOSAIC_PROGRESS":
      return Math.round(action.progress * 100);
    default:
      return state;
  }
};

const completed = (state = false, action) => {
  switch (action.type) {
    case "FINISH_GENERATING_MOSAIC":
      return true;
    case "START_GENERATING_MOSAIC":
      return false;
    default:
      return state;
  }
};
const canRegenerate = (state = false, action) => {
  switch (action.type) {
    case "FINISH_GENERATING_MOSAIC":
      return false;
    case "SET_MOSAIC_TARGET":
    case "CROP_MOSAIC_TARGET":
    case "ADD_MOSAIC_TILES":
    case "REMOVE_MOSAIC_TILE":
    case "CLEAR_MOSAIC_TILES":
      return true;
    default:
      return state;
  }
};
const nofTileOutput = (state = 0, action) => {
  switch (action.type) {
    case "FINISH_GENERATING_MOSAIC":
      return action.nofTileOutput;
    case "START_GENERATING_MOSAIC":
      return 0;
    default:
      return state;
  }
};

const isPortrait = (state = null, action) => {
  switch (action.type) {
    case "FINISH_GENERATING_MOSAIC":
      return action.isPortrait;
    case "START_GENERATING_MOSAIC":
      return null;
    default:
      return state;
  }
};
const recommendedOverlay = (state = 0.35, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
const overlay = (state = 0.35, action) => {
  switch (action.type) {
    case "UPDATE_MOSAIC_OVERLAY":
      return action.overlay;
    default:
      return state;
  }
};
export default combineReducers({
  target,
  tiles,
  preview,
  generating,
  error,
  progress,
  completed,
  canRegenerate,
  recommendedOverlay,
  overlay,
  nofTileOutput,
  isPortrait,
  editorsPicks
});

export const getTiles = state => fromTiles.filtered(state.tiles);



// WEBPACK FOOTER //
// ./src/reducers/mosaic/index.js